/** Format ISO datetime to DD.MM.YYYY; HH:MM in the browser's local timezone. */
export function formatDateTime(iso: string): string {
  if (!iso) return "-";
  const d = new Date(iso);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  const hours = String(d.getHours()).padStart(2, "0");
  const minutes = String(d.getMinutes()).padStart(2, "0");
  return `${day}.${month}.${year}; ${hours}:${minutes}`;
}
